/* file description */
import SpSteps from './steps';
import FilterTree from './filterTree';
import SampleDraftTree from './sampleDraftTree';
import FilterTreeRead from './filterTreeRead';

const componentsList = {
  process: SpSteps,
  filterTree: FilterTree,
  sampleDraftTree: SampleDraftTree,
  filterTreeRead: FilterTreeRead,
};

export default componentsList;
